import React from 'react';
import HeroCarousel from '../components/home/HeroCarousel';
import { PrioritiesBand, AboutNews, CoreValuesBlock, AnniversaryBlock } from '../components/home/Sections';
import LeadershipGrid from '../components/home/LeadershipGrid';

const Home = () => (
  <>
    <HeroCarousel />
    <PrioritiesBand />
    <AboutNews />
    <LeadershipGrid />
    <CoreValuesBlock />
    <AnniversaryBlock />
  </>
);

export default Home;
